export default {
  en: {
    title: 'Frequently Asked Questions',
    subtitle: 'Find answers to common questions about our products and services',
    international_support: 'International Support',
    still_have_questions: 'Still Have Questions?',
    contact_us: 'Contact Us',
    questions: {
      q1: 'What types of cranes and hoists do you manufacture?',
      q2: 'Do you provide installation services for your equipment?',
      q3: 'What is the warranty period for your products?',
      q4: 'Can you customize cranes according to specific requirements?',
      q5: 'How long does it take to manufacture and deliver a crane?',
      q6: 'Do you provide after-sales service internationally?'
    },
    answers: {
      a1: 'We manufacture a wide range of cranes and hoists including overhead cranes, gantry cranes, jib cranes, electric wire rope hoists, electric chain hoists, and various lifting equipment. Our products are suitable for different industries and applications.',
      a2: 'Yes, we provide comprehensive installation services for all our equipment. Our experienced engineers can travel worldwide to supervise installation and provide training to your local maintenance teams.',
      a3: 'Our standard warranty period is 12 months from the date of installation or 18 months from the date of shipment, whichever comes first. Extended warranty options are also available. Fuhai takes responsibility for its machines during their entire working life, supplying spare parts and after-service support.',
      a4: 'Absolutely! We specialize in customizing cranes and hoists according to specific customer requirements. Our engineering team can design and manufacture equipment tailored to your unique specifications, working environment, and lifting needs.',
      a5: 'The manufacturing and delivery time depends on the complexity and size of the order. Typically, standard products take 30-45 days for production, while customized solutions may take 60-90 days. We always provide a detailed timeline during the quotation process.',
      a6: 'Yes, we provide comprehensive after-sales service internationally. While we may not have physical offices in all countries, we can dispatch engineers when needed and provide remote support. We also help connect customers with local maintenance resources in their area.'
    }
  },
  zh: {
    title: '常见问题',
    subtitle: '查找有关我们产品和服务的常见问题解答',
    international_support: '国际支持',
    still_have_questions: '还有疑问？',
    contact_us: '联系我们',
    questions: {
      q1: '您生产哪些类型的起重机和吊具？',
      q2: '您是否为您的设备提供安装服务？',
      q3: '您的产品保修期是多久？',
      q4: '您能根据特定要求定制起重机吗？',
      q5: '制造和交付起重机需要多长时间？',
      q6: '您是否提供国际售后服务？'
    },
    answers: {
      a1: '我们生产各种起重机和吊具，包括桥式起重机、门式起重机、悬臂起重机、电动钢丝绳吊具、电动链条吊具以及各种起重设备。我们的产品适用于不同行业和应用场景。',
      a2: '是的，我们为所有设备提供全面的安装服务。我们经验丰富的工程师可以前往世界各地监督安装并为您的本地维护团队提供培训。',
      a3: '我们的标准保修期为自安装之日起12个月或自发货之日起18个月，以先到者为准。我们还提供延长保修选项。福海在机器的整个工作寿命期间对其负责，提供备件和售后服务支持。',
      a4: '当然可以！我们专注于根据客户的特定需求定制起重机和吊具。我们的工程团队可以设计和制造符合您独特规格、工作环境和起重需求的设备。',
      a5: '制造和交付时间取决于订单的复杂程度和规模。通常，标准产品需要30-45天生产，而定制解决方案可能需要60-90天。我们在报价过程中始终提供详细的时间表。',
      a6: '是的，我们提供全面的国际售后服务。虽然我们可能不在所有国家都设有实体办事处，但我们可以在需要时派遣工程师并提供远程支持。我们还帮助客户与其所在地区的本地维护资源建立联系。'
    }
  }
}
